/* eslint-disable */

/* Youtube Api has to be global */
window.player = '';
window.YoutubeClientID = '';
window.muted = true;

window.onYouTubeIframeAPIReady = function () {
    if (YoutubeClientID !== null && YoutubeClientID !== '') {
        player = new YT.Player(YoutubeClientID, {
            events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange,
            },
        });
    }
};
window.onPlayerReady = function (event) {
    if (muted) event.target.mute();
    event.target.playVideo();
};
window.onPlayerStateChange = function (event) {
    // function(event.data){};
};

window.InitYoutubeAutoplayVideo = function (containerId, muted) {
    window.muted = muted;
    YoutubeClientID = containerId;
    const tag = document.createElement('script');
    tag.id = `APIScriptFor_${YoutubeClientID}`;
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};
